// Utility functions for generating closed SVG path polygons for EnergyFlowDiagram

/**
 * Generates a closed path for the left flow (Sankey-style) between two bars.
 * @param {number} barTopX
 * @param {number} barTopY
 * @param {number} barX
 * @param {number} barY
 * @param {number} barWidth
 * @param {number} barHeight
 * @returns {string} SVG path string
 */
export function getLeftFlowPath(barTopX, barTopY, barX, barY, barWidth, barHeight) {
  return `
    M${barTopX} ${barTopY + barHeight}
    C${barTopX} ${(barTopY + barY) / 2}, ${barX} ${(barTopY + barY) / 2}, ${barX} ${barY}
    L${barX + barWidth} ${barY}
    C${barX + barWidth} ${(barTopY + barY) / 2}, ${barTopX + barWidth} ${(barTopY + barY) / 2}, ${barTopX + barWidth} ${barTopY + barHeight}
    L${barTopX + barWidth} ${barTopY}
    L${barTopX} ${barTopY}
    Z
  `;
}

/**
 * Generates a closed path for the right main flow (Sankey-style).
 * @param {number} barMirrorX
 * @param {number} barMirrorY
 * @param {number} barHeight
 * @param {number} topMainWidth
 * @param {number} initRxBottom
 * @param {number} initRy
 * @returns {string} SVG path string
 */
export function getRightMainFlowPath(barMirrorX, barMirrorY, barHeight, topMainWidth, initRxBottom, initRy) {
  return `
    M${barMirrorX} ${barMirrorY + barHeight}
    C${barMirrorX} ${(barMirrorY + initRy) / 2}, ${initRxBottom} ${(barMirrorY + initRy) / 2}, ${initRxBottom} ${initRy}
    L${initRxBottom + topMainWidth} ${initRy}
    C${initRxBottom + topMainWidth} ${(barMirrorY + initRy) / 2}, ${barMirrorX + topMainWidth} ${(barMirrorY + initRy) / 2}, ${barMirrorX + topMainWidth} ${barMirrorY + barHeight}
    Z
  `;
}

/**
 * Generates a closed path for the right split flow (Sankey-style).
 * @param {number} pvSplitXDynamic
 * @param {number} barMirrorY
 * @param {number} barHeight
 * @param {number} pvSplitWidthDynamic
 * @param {number} windSplitWidthDynamic
 * @param {number} initRxBottom
 * @param {number} initRy
 * @returns {string} SVG path string
 */
export function getRightSplitFlowPath(pvSplitXDynamic, barMirrorY, barHeight, pvSplitWidthDynamic, windSplitWidthDynamic, initRxBottom, initRy, barWidth) {
  return `
    M${pvSplitXDynamic} ${barMirrorY + barHeight}
    C${pvSplitXDynamic} ${(barMirrorY + initRy) / 2}, ${initRxBottom + barWidth - windSplitWidthDynamic - pvSplitWidthDynamic} ${(barMirrorY + initRy) / 2}, ${initRxBottom + barWidth - windSplitWidthDynamic - pvSplitWidthDynamic} ${initRy}
    L${initRxBottom + barWidth - windSplitWidthDynamic} ${initRy}
    C${initRxBottom + barWidth - windSplitWidthDynamic} ${(barMirrorY + initRy) / 2}, ${pvSplitXDynamic + pvSplitWidthDynamic} ${(barMirrorY + initRy) / 2}, ${pvSplitXDynamic + pvSplitWidthDynamic} ${barMirrorY + barHeight}
    Z
  `;
}

/**
 * Generates a closed path for the right wind flow (Sankey-style).
 * @param {number} windSplitXDynamic
 * @param {number} barMirrorY
 * @param {number} barHeight
 * @param {number} windSplitWidthDynamic
 * @param {number} initRxBottom
 * @param {number} barWidth
 * @param {number} initRy
 * @returns {string} SVG path string
 */
export function getRightWindFlowPath(windSplitXDynamic, barMirrorY, barHeight, windSplitWidthDynamic, initRxBottom, barWidth, initRy) {
  return `
    M${windSplitXDynamic} ${barMirrorY + barHeight}
    C${windSplitXDynamic} ${(barMirrorY + initRy) / 2}, ${initRxBottom + barWidth - windSplitWidthDynamic} ${(barMirrorY + initRy) / 2}, ${initRxBottom + barWidth - windSplitWidthDynamic} ${initRy}
    L${initRxBottom + barWidth} ${initRy}
    C${initRxBottom + barWidth} ${(barMirrorY + initRy) / 2}, ${windSplitXDynamic + windSplitWidthDynamic} ${(barMirrorY + initRy) / 2}, ${windSplitXDynamic + windSplitWidthDynamic} ${barMirrorY + barHeight}
    Z
  `;
}
